<script lang="ts" setup>
import homeLogoForbes from '@consumer/assets/images/media-logos/forbes.png'
import homeLogoTechCrunch from '@consumer/assets/images/media-logos/tech-crunch.png'
import homeLogoCondeNastTraveler from '@consumer/assets/images/media-logos/conde-nast-traveler.png'
import homeLogoNewYork from '@consumer/assets/images/media-logos/new-york.png'
import homeLogoBusinessInsider from '@consumer/assets/images/media-logos/business-insider.png'
import { isDesktop } from '@consumer/utils/breakpoints'
</script>

<template>
  <div class="w-full flex justify-evenly items-center">
    <img
      :src="homeLogoForbes"
      class="object-contain"
      alt="Forbes"
      :width="isDesktop ? 76 : 51"
      height="32"
    >
    <img
      :src="homeLogoTechCrunch"
      class="object-contain <lg:hidden"
      alt="TechCrunch"
      :width="isDesktop ? 152 : 47"
      height="32"
    >
    <img
      :src="homeLogoCondeNastTraveler"
      class="object-contain"
      alt="Conde Nast"
      :width="isDesktop ? 85 : 51"
      height="32"
    >
    <img
      :src="homeLogoNewYork"
      class="object-contain"
      alt="New York"
      :width="isDesktop ? 136 : 72"
      height="32"
    >
    <img
      :src="homeLogoBusinessInsider"
      class="object-contain"
      alt="Business Insider"
      :width="isDesktop ? 104 : 51"
      height="32"
    >
  </div>
</template>
